// Bootstrap
import { Tooltip, Toast, Popover, Dropdown, Modal } from 'bootstrap'; 

// GLIGHTBOX  
import GLightbox from 'glightbox';

// CSS
import '../scss/libraries.scss';
import '../scss/app.scss';
import '../scss/admin.scss';  

// COMPONENTS
import './components/loader'; 
import './components/searchform'; 
import './components/stickyHeader'; 
import './components/swiper-carrousels';  
import './components/glightbox-gallery';  
import './components/request-visit-form';  

// UTILS
import js2Css from './js-utils/variablesJs2Css';
import moveModalsToEnd from './js-utils/moveModalsToEnd';


// -----------------
// EVENTS TRIGGERS
// -----------------

document.addEventListener('DOMContentLoaded', () => {


	// CSS Variables
	if(document.querySelector('header'))
		js2Css.add( 'header-height', document.querySelector('header').offsetHeight + 'px');

	
	js2Css.add('vh', window.innerHeight + 'px');


	// Moving Modals to the end of body.
	moveModalsToEnd();


    // Init glightbox 
    GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });
    


});

window.addEventListener('load', () => {
    // Masonry Layouts 
    // masonryLayouts();
})

// SCROLL
window.addEventListener('scroll', function () {
	js2Css.add('vh', window.innerHeight + 'px');

});


